import styled from "styled-components";

import { Select } from "discover.medical.react-component-library";

export const Wrapper = styled.div`
  display: flex;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: 0.75rem;
  }
`;

export const Label = styled.label`
  display: flex;
  align-self: center;
  color: ${({ theme }) => theme.colors.gray900};
  margin-right: ${({ theme }) => theme.space.sm};
`;

export const SelectField = styled(Select)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 13.5rem;
  }

  select {
    height: 2rem;
  }
`;
